// HATV section Q month details API

import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

interface HATVAboStatisticParams {
  affiliateCode: String | Number;
  aboNumber: String | Number;
  closingMonth: String | Number;
}

interface UpdateApprovalStatusArgType {
  affiliateCode: string;
  aboNumber: string;
  payload: {
    closingMonth: string;
    approvalStatus: number;
    note: string;
  };
}

interface HATVQmonthLegsRes {
  statusCode: number;
  body: {
    closingMonth: string;
    legs: [
      {
        affiliateCode: string;
        aboNumber: string;
        name: string;
        localName: string;
        marketCountryCode: string;
        marketName: string;
        legType: number;
        qMonth: number;
        legTypeName: string;
        currentAward: {
          awardCode: string;
          awardName: string;
        };
        highestAward: {
          awardCode: string;
          awardName: string;
        };
      },
    ];
  };
  error: [];
}

export const hatvQmonthDetailsAPI = createApi({
  reducerPath: "HATVQMonthDetailsAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  tagTypes: ["hatvqmonthdetails"],
  endpoints: (builder) => ({
    getHATVQmonthDetailsAPI: builder.query<any, HATVAboStatisticParams>({
      query: ({ closingMonth, affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/qdetail/month/${closingMonth}`,
        method: "GET",
      }),
    }),
    getHATVQmonthLegsAPI: builder.query<
      HATVQmonthLegsRes,
      HATVAboStatisticParams
    >({
      query: ({ closingMonth, affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/legs/month/${closingMonth}`,
        method: "GET",
      }),
    }),
    getHATVQmonthDetailsAIInsightSummary: builder.query<
      any,
      HATVAboStatisticParams
    >({
      query: ({ closingMonth, affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/insight/summary/month/${closingMonth}`,
        method: "GET",
      }),
    }),
    updateQmonthApprovalStatus: builder.mutation<any, UpdateApprovalStatusArgType>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/approval`,
        method: "POST",
        data: payload,
      }),
      transformResponse: (res: {
        body: any;
        statusCode: number;
        error: {
          errorCode: number;
          errorMessage: string;
        }[];
      }) => {
        if ([200, 201].includes(res.statusCode)) return res.body;
        throw res.error[0];
      },
    }),
  }),
});

export const { useLazyGetHATVQmonthDetailsAPIQuery, useGetHATVQmonthLegsAPIQuery, useGetHATVQmonthDetailsAIInsightSummaryQuery, useUpdateQmonthApprovalStatusMutation } =
  hatvQmonthDetailsAPI;
